import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const LoginByToken = Loadable(lazy(() => import('../pages/auth/LoginByToken')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const VerifyEmailCodePage = Loadable(
  lazy(() => import('../pages/auth/VerifyEmailCodePage'))
);
export const VerifyEmailPage = Loadable(lazy(() => import('../pages/auth/VerifyEmailPage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// LAYOUTS
export const MainLayout = Loadable(lazy(() => import('../layouts/main')));
export const CompactLayout = Loadable(lazy(() => import('../layouts/compact')));
export const DashboardLayout = Loadable(lazy(() => import('../layouts/dashboard')));
export const TrainerDashboardLayout = Loadable(lazy(() => import('../layouts/trainer')));
export const AdminDashboardLayout = Loadable(lazy(() => import('../layouts/admin')));

// DASHBOARD: Admin
export const AdminDashboardPage = Loadable(lazy(() => import('../pages/admin/AdminDashboardPage')));
export const AdminProductListPage = Loadable(
  lazy(() => import('../pages/admin/AdminProductListPage'))
);
export const AdminProductsubListPage = Loadable(
  lazy(() => import('../pages/admin/AdminProductsubListPage'))
);
export const AdminSubscriptionListPage = Loadable(
  lazy(() => import('../pages/admin/AdminSubscriptionListPage'))
);
export const AdminCouponListPage = Loadable(
  lazy(() => import('../pages/admin/AdminCouponListPage'))
);
export const AdminTrackListPage = Loadable(lazy(() => import('../pages/admin/AdminTrackListPage')));
export const AdminPromoListPage = Loadable(lazy(() => import('../pages/admin/AdminPromoListPage')));
export const AdminMetaStriderListPage = Loadable(
  lazy(() => import('../pages/admin/AdminMetaStriderListPage'))
);
export const AdminHorseListPageDashboard = Loadable(
  lazy(() => import('../pages/admin/AdminHorseListPageDashboard'))
);
export const AdminCreateTrackPage = Loadable(
  lazy(() => import('../pages/admin/AdminCreateTrackPage'))
);
export const AdminCreatePromoPage = Loadable(
  lazy(() => import('../pages/admin/AdminCreatePromoPage'))
);
export const AdminHorseOwnershipListPageDashboard = Loadable(
  lazy(() => import('../pages/admin/AdminHorseOwnershipListPageDashboard'))
);
export const AdminHorseOwnershipPendingListPageDashboard = Loadable(
  lazy(() => import('../pages/admin/AdminHorseOwnershipPendingListPageDashboard'))
);
export const AdminWorkoutHorseListPage = Loadable(
  lazy(() => import('../pages/admin/AdminWorkoutHorseListPage'))
);
export const AdminSingleWorkoutViewPage = Loadable(
  lazy(() => import('../pages/admin/AdminSingleWorkoutViewPage'))
);
export const AdminUserListPage = Loadable(lazy(() => import('../pages/admin/AdminUserListPage')));
export const AdminDatabaseManagerPage = Loadable(
  lazy(() => import('../pages/admin/AdminDatabaseManagerPage'))
);

export const AdminNotificationPage = Loadable(
  lazy(() => import('../pages/admin/AdminNotificationPage'))
);

// DASHBOARD: Trainer
export const TrainerDashboard = Loadable(lazy(() => import('../pages/trainer/TrainerDashboard')));
export const TrainerHorseListPage = Loadable(
  lazy(() => import('../pages/trainer/TrainerHorseListPage'))
);
export const AddHorsePage = Loadable(lazy(() => import('../pages/trainer/AddHorsePage')));
export const TrainerWorkoutHorseListPage = Loadable(
  lazy(() => import('../pages/trainer/TrainerWorkoutHorseListPage'))
);

// DASHBOARD: OWNER
export const OwnerDashboard = Loadable(lazy(() => import('../pages/owner/OwnerDashboard')));
export const OwnerTackListPage = Loadable(
  lazy(() => import('../pages/owner/OwnerTackListPage'))
);
export const OwnerWorkoutHorseListPage = Loadable(
  lazy(() => import('../pages/owner/OwnerWorkoutHorseListPage'))
);
export const OwnerHorseListPage = Loadable(
  lazy(() => import('../pages/owner/OwnerHorseListPage'))
);

// SHOP: ECOMMERCE

export const EcommerceShopPage = Loadable(lazy(() => import('../pages/shop/EcommerceShopPage')));
export const EcommerceCheckoutPage = Loadable(
  lazy(() => import('../pages/shop/EcommerceCheckoutPage'))
);
export const EcommerceProductDetailsPage = Loadable(
  lazy(() => import('../pages/shop/EcommerceProductDetailsPage'))
);
export const EcommerceSubscriptionShopPage = Loadable(
  lazy(() => import('../pages/shop/EcommerceSubscriptionShopPage'))
);
export const EcommerceSubscriptionDetailsPage = Loadable(
  lazy(() => import('../pages/shop/EcommerceSubscriptionDetailsPage'))
);
export const EcommerceProductListPage = Loadable(
  lazy(() => import('../pages/owner/EcommerceProductListPage'))
);
export const EcommerceProductCreatePage = Loadable(
  lazy(() => import('../pages/owner/EcommerceProductCreatePage'))
);
export const EcommerceProductEditPage = Loadable(
  lazy(() => import('../pages/owner/EcommerceProductEditPage'))
);

// DASHBOARD: USER
export const UserAccountPage = Loadable(lazy(() => import('../pages/owner/UserAccountPage')));

// DASHBOARD: COMMON
export const SubscriptionListPage = Loadable(
  lazy(() => import('../pages/common/SubscriptionListPage'))
);
export const MyOrdersPage = Loadable(lazy(() => import('../pages/common/MyOrdersPage')));
export const WorkoutDetailsPage = Loadable(
  lazy(() => import('../pages/common/WorkoutDetailsPage'))
);
export const HorseEditPage = Loadable(lazy(() => import('../pages/common/HorseEditPage')));

// MAIN
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const TutorialsPage = Loadable(lazy(() => import('../pages/TutorialsPage')));
export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));
export const TermsPage = Loadable(lazy(() => import('../pages/TermsPage')));
export const PrivacyPage = Loadable(lazy(() => import('../pages/PrivacyPage')));
